import { render, staticRenderFns } from "./UserFormImport.vue?vue&type=template&id=2e23c356&"
import script from "./UserFormImport.vue?vue&type=script&lang=js&"
export * from "./UserFormImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports